import React from 'react';
import { useTranslation } from 'react-i18next';
import * as THREE from 'three';

import { InputHandler } from '../../../../../viewer/input-handler';
import { PoiTool } from '../../../../../viewer/tools/poi-tool';
import { useDialog } from '../../../../hooks/use-dialog';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { PoiDialog } from '../../asset-menu/dialogs/poi-dialog/poi-dialog';
import { ToolIcon } from '../tool-icon';

const PoiToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);
  const [pickedLocalPosition, setPickedLocalPosition] = React.useState<THREE.Vector3 | undefined>();
  const poiDialog = useDialog();

  return (
    <>
      <ToolIcon
        active={activeTool instanceof PoiTool}
        callback={() => {
          InputHandler.instance.setTool('poi');
          const commentTool = InputHandler.instance.currentTool() as PoiTool;
          commentTool.onPoiPlaced = (localPosition: THREE.Vector3) => {
            poiDialog.show();
            setPickedLocalPosition(localPosition);
          };
        }}
        disabled={false}
        icon={['fal', 'location-dot']}
        tooltip={{
          title: t('poi.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('poi.tooltip.text', { ns: 'skyviewToolbar' }),
        }}
      />

      {poiDialog.render(() => {
        const poiTool = InputHandler.instance.currentTool() as PoiTool;
        return (
          <PoiDialog
            context={{ type: 'NEW', localPosition: pickedLocalPosition ?? new THREE.Vector3() }}
            onClose={() => {
              poiDialog.hide();
              poiTool.removePointer();
            }}
          />
        );
      })}
    </>
  );
};

export { PoiToolIcon };
